export default {
  init() {
    // JavaScript to be fired on all pages
    let menuAbierto = false;
    const esHome = $('body').hasClass('home') || $('body').hasClass('front-page');
    const $banner = $('.banner');
    const altura = $banner.length ? $banner.offset().top : 0;

    function getHeaderOffset() {
      if (!$banner.length) {
        return 0;
      }

      const headerHeight = $banner.outerHeight();
      const viewportWidth = window.innerWidth || $(window).width();
      const extraGap = viewportWidth <= 768 ? 16 : 20;

      return Math.max(headerHeight + extraGap, 0);
    }

    function scrollToHash(hash) {
      let $target = $(hash);
      if (!$target.length && hash.length > 1) {
        $target = $('[name="' + hash.slice(1) + '"]');
      }

      if (!$target.length) {
        return false;
      }

      const targetOffset = $target.offset().top - getHeaderOffset();
      $('html,body').stop(true).animate({ scrollTop: targetOffset }, 800);
      return true;
    }

    function debeIrAHomeConHash(linkElement, hash) {
      if (!hash || hash === '#' || esHome) {
        return false;
      }

      const href = (linkElement.getAttribute('href') || '').trim();
      const pathEnlace = (linkElement.pathname || '').replace(/\/+$/, '');
      const pathActual = location.pathname.replace(/\/+$/, '');
      const esSoloHash = href.charAt(0) === '#';
      const apuntaRaiz = pathEnlace === '' || pathEnlace === '/';
      const apuntaPaginaActual = pathEnlace === pathActual;
      const estaEnMenu = $(linkElement).closest('.navbar, .menuMovil').length > 0;

      return estaEnMenu && (esSoloHash || apuntaRaiz || apuntaPaginaActual);
    }

    function handleHashNavigation() {
      const hash = window.location.hash;

      if (!hash || hash === '#') {
        return;
      }

      if (!$(hash).length && !$('[name="' + hash.slice(1) + '"]').length) {
        return;
      }

      setTimeout(function() {
        scrollToHash(hash);
      }, 150);
    }

    function cerrarMenuMovil() {
      $('.hamburger').removeClass('is-active');
      $('.menuMovil').animate({
        left: '-100vw',
      }, 500);
      menuAbierto = false;
    }

    $('.hamburger').on('click', function() {
      $(this).toggleClass('is-active');

      if (menuAbierto) {
        cerrarMenuMovil();
        return;
      }

      $('.menuMovil').animate({
        left: '0',
      }, 500);
      menuAbierto = true;
    });

    $(document).on('click', '.menuMovil #menu-menu-movil a', function(event) {
      const hash = this.hash || '';

      if (!hash || hash === '#') {
        return;
      }

      if (debeIrAHomeConHash(this, hash)) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        cerrarMenuMovil();
        window.location.href = '/' + hash;
        return false;
      }

      if (!esHome) {
        return;
      }

      if (this.pathname.replace(/\//g, '') !== location.pathname.replace(/\//g, '')
        && this.pathname !== '/' && this.pathname !== '') {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (scrollToHash(hash)) {
        cerrarMenuMovil();
        return false;
      }

      cerrarMenuMovil();
      window.location.href = '/' + hash;
      return false;
    });

    $('a[href*="#"]').not('.menuMovil a').on('click', function() {
      const hash = this.hash || '';

      if (!hash || hash === '#') {
        return;
      }

      if (debeIrAHomeConHash(this, hash)) {
        window.location.href = '/' + hash;
        return false;
      }

      if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '')
        && location.hostname === this.hostname) {
        if (scrollToHash(hash)) {
          return false;
        }
      }
    });

    $(window).on('scroll', function() {
      if ($(window).scrollTop() > altura) {
        $('header').addClass('menu-fixed');
        $('.promo-header').css('display', 'none');
        $('.top-header').css('display', 'none');
      } else {
        $('header').removeClass('menu-fixed');
        $('.promo-header').css('display', 'block');
        $('.top-header').css('display', 'block');
      }
    });

    $(window).on('load', handleHashNavigation);
    $(window).on('hashchange', handleHashNavigation);

    const images = document.querySelectorAll('img');

    images.forEach(function(image) {
      if (!image.hasAttribute('alt') || image.alt.trim() === '') {
        const pageTitle = document.title || 'Título de la página';
        const imageUrl = image.src || '';
        const imageName = imageUrl.split('/').pop().split('.')[0];

        image.setAttribute('alt', pageTitle + ' - ' + imageName);
      }
    });

    const campoNombre = document.querySelector('input[name="nombre"]');
    const campoEmail = document.querySelector('input[name="email"]');
    const campoCheck = document.querySelector('input[name="terms"]');

    if (campoNombre) {
      campoNombre.setAttribute('aria-label', 'Nombre completo');
    }

    if (campoCheck) {
      campoCheck.setAttribute('aria-label', 'Acepta condiciones');
    }

    if (campoEmail) {
      campoEmail.setAttribute('aria-label', 'Introduce aqui el Correo electrónico');
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js